<template>
  <page-container @window-return="refresh">
    <search-bar :items="[
      { key: 'category_ids', label: 'Categories', type: 'categroup' },
      { key: 'part_no_search', label: 'Part Number', type: 'multi', width: 260 },
      { key: 'description', label: 'Description', type: 'multi', width: 260 },
      { key: 'brand', label: 'Brand', type: 'multi', width: 160 },
      { key: 'class_id', label: 'Class', type: 'select', state: 'class', option_value: 'id', option_label: 'name', width: 260 },
      { key: 'sales_id', label: 'Sales', type: 'select', state: 'sales', option_value: 'id', option_label: 'realname', width: 120 },
      { key: 'datetime', label: 'Date', type: 'daterange', defaultValue: defDate, disabledDays: user.role_id < 3 ? 366 : 7 }
    ]" @search="search"/>

    <div class="card">
      <div flex>
        <div>
          <!--
          <el-button round size="small" icon="el-icon-printer" @click="print">Print</el-button>
          -->
          <el-button round size="small" icon="el-icon-document">To Excel</el-button>
        </div>
        <el-pagination 
          @size-change="pageSizeChange" 
          @current-change="pageChange" 
          :current-page="currentPage" 
          :page-sizes="[20, 50, 100, 500]" 
          :page-size="pageSize" 
          layout="total, sizes, pager" 
          :total="total" 
          style="text-align:right;"
          flex-box="1">
        </el-pagination>
      </div>

      <cate-table :columns="[
        { key: 'part_no', title: 'Part Number' },
        { key: 'description', title: 'Description' },
        { key: 'brand', title: 'Brand' },
        { key: 'doc_id_display', title: 'PO No.', emit: 'doc-id-click' },
        { key: 'qty', title: 'Qty' },
        { key: 'price', title: 'Price' }
      ]"
      :data="list"
      :loading="loading"
      show-detail
      show-cart
      @detail-click="$open(`/product/${arguments[0]}/details`)"
      @part-click="$open(`/product/${arguments[0]}/po`)"
      @doc-id-click="docIdClick(arguments[0].doc_id)"
      style="margin:10px 0;" />

      <el-pagination @size-change="pageSizeChange" @current-change="pageChange" :current-page="currentPage" :page-sizes="[20, 50, 100, 500]" :page-size="pageSize" layout="total, sizes, pager" :total="total" style="text-align:right;"></el-pagination>
    </div>
  </page-container>
</template>

<script>
import moment from 'moment'
import ListFunc from '@/mixins/ListFunc'
export default {
  mixins: [ListFunc],
  data () {
    return {
      sqlcode: 'po_list',
      defDate: [moment().subtract(7, 'days'), moment().endOf('day')]
    }
  },
  computed: {
    user () {
      return this.$store.state.user
    }
  },
  methods: {
    docIdClick (id) {
      if (this.user.role_id < 3) {
        this.$open(`/po-order-view/${id}`, 840)
      }
    }
  }
}
</script>